import { render } from "./ProfileModal.vue?vue&type=template&id=b4a3c204&scoped=true"
import script from "./ProfileModal.vue?vue&type=script&lang=js"
export * from "./ProfileModal.vue?vue&type=script&lang=js"

import "@/assets/css/components/ProfileModal.scss?vue&type=style&index=0&id=b4a3c204&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b4a3c204"]])

export default __exports__